<div class="input-wrapper mb-3"
     [ngClass]="{ 'input-wrapper--error': fc.touched && fc.errors }">
  <div *ngIf="label" class="input-wrapper__title mb-1">
    <label>
      {{ label }}
      <span
        *ngIf="!fc?.value && fc?.errors?.required"
        class="required-asterisk"
      >
        *
      </span>
    </label>
    <ng-content select="[top-right]"></ng-content>
  </div>
  <div class="input-wrapper__field-wrap">
    <angular2-multiselect #multiSelect
                          [data]="options"
                          [formControl]="innerControl"
                          [settings]="dropdownSettings">
    </angular2-multiselect>
    <div class="d-none required-label"
         [ngClass]="{'d-block': fc.touched && fc?.errors?.required}"
    >
      Required field
    </div>
  </div>
</div>
